export const getConfig = () => {
  return {
    pagination: false,
    rowSelection: false,
    fieldControl: false,
    tableType: 'antd',
    columns: [
      {
        title: '项目/通项',
        width: 200,
        dataIndex: ['dtlName'],
      },
      {
        title: '类型',
        width: 120,
        dataIndex: ['busTypeName'],
      },
      {
        title: '适用门店',
        width: 200,
        dataIndex: ['shopList'],
        render: 'companyRender',
      },
      {
        title: '创建人',
        width: 200,
        dataIndex: ['createdByName'],
      },
      {
        title: '创建时间',
        width: 180,
        dataIndex: ['createdTime'],
        itemType: 'dateTime',
      },
      {
        title: '操作',
        dataIndex: '#',
        render: 'actionRender',
        fixed: 'right',
        width: 220,
      },
    ],
    footer: [
      {
        label: '添加项目',
        type: 'primary',
        disabled: 'projectBtnDisabled',
        events: ['onClick:onAddProject'],
      },
      {
        label: '添加通项',
        type: 'primary',
        disabled: 'generalBtnDisabled',
        events: ['onClick:onAddGeneral'],
      },
    ],
    search: [
      {
        name: 'showNameKey',
        label: '项目/通项',
      },
    ],
  }
}
